import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

import { ValBrowserStorageService } from '../services/val-browser-storage.service';
import { ValService } from '../services/val.service';

@Component({
  selector: 'val-login',
  templateUrl: './val-login.component.html',
  styleUrls: ['./val-login.component.scss']
})
export class ValLoginComponent implements OnInit {
  private returnRoute = '';
  public UserName = '';
  public Password = '';

  constructor(
    private _srvc: ValService,
    private _st: ValBrowserStorageService,
    private _cr: ActivatedRoute,
    private _r: Router,
  ) { }

  public ngOnInit(): void {
    this.returnRoute = this._cr.snapshot.paramMap.get('url');
    this.returnRoute = this.returnRoute ? this.returnRoute : '';
    this.returnRoute = this.returnRoute.includes('login') ? '' : this.returnRoute;
    this._st.logOut();
  }

  public login = () => {
    this._srvc.GetUserCashRegisters({ userName: this.UserName, password: this.Password }).pipe(
      take(1),
      switchMap(uc => {
        if (uc) {
          const cashRegisterId = uc.filter(x => x.IsDefault).map(x => x.Id).reduceRight((_a, b) => b, null);
          return this._srvc.GetToken({ userName: this.UserName, password: this.Password, cashRegisterId: cashRegisterId, channelId: '', extUserId: '' }).pipe(
            take(1),
            switchMap(t => {
              this._st.addTokenToStorage(t.access_token, null, cashRegisterId);
              return this._srvc.getUserinfo().pipe(
                take(1),
                tap(ui => {
                  this._st.addTokenToStorage(t.access_token, ui, cashRegisterId);
                  this._r.navigate([this.returnRoute]);
                  return null;
                })
              );
            }));
        }
        return of(null);
      })
    ).subscribe();

    // this.srvc.GetToken({ userName: this.UserName, password: this.Password, cashRegisterId: this._s.cashRegisterId, channelId: '', extUserId: '' }).pipe(
    //   take(1),
    //   tap(x => {
    //     this.st.addTokenToStorage(x.access_token, this.UserName);
    //     this.st.getCurrentUser();
    //     this.r.navigate([this.returnRoute]);
    //     return x;
    //   })).subscribe();
  }
}


